/** @jsxImportSource @emotion/react */
import { StageV2 } from 'modules/championship/domain/interfaces/stage';
import { stageProcessingSelector } from 'modules/championship/store/stages';
import { fetchStageStatistics } from 'modules/championship/store/stages/stages.actions';
import { Table } from 'modules/championship/ui/components/form-parts/stages/stage-grid/stage-group/stage-group-table';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'store/store';
import type { DivProps } from 'typings';
import * as S from './styles';

interface IStageStandingProps extends DivProps {
  stage: StageV2;
}

function StageStanding(props: IStageStandingProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { stage, ...rest } = props;

  const processing = useSelector(stageProcessingSelector);
  const isLoading = useMemo(() => {
    return processing.processingName === 'fetchStageStatistics';
  }, [processing.processingName]);

  useEffect(() => {
    dispatch(fetchStageStatistics({ stageId: stage.id }));
  }, [dispatch]);

  return (
    <S.MainBlock {...rest}>
      <Table isEditMode={false} isLoading={isLoading} teams={stage.teams} statistics={stage.statistics ?? []} />
    </S.MainBlock>
  );
}

export default StageStanding;
